import axios from 'axios';
import Vue from 'vue';

// 创建axios实例
let server = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout:60000,
});

// 请求拦截器
server.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么

    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 响应拦截器
// {
//   "code": 0,                     #业务层的状态码 与 response.status 不同，0表示成功、非0表示错误，错误信息在error中保存
//   "error": "",                   #当code不为0的时，具体的错误信息
//   "detail": {			              #业务端返回的数据，object类型
//       "username": "13583168428",
//       "nickName": "测试测试"
//   }
// }
server.interceptors.response.use(function (response) {

  // 对响应数据做点什么
   //console.log('response：:',response);
  if(response.status === 200){
    const isBlob = response.data instanceof Blob;
    if(isBlob) {
        return response;
    }else{
      // 如果code != 0 是出错信息
      let result = response.data;
      if (result.code != 0) {
        //console.log('result.code = ' + result.code+",result.error:"+result.error);
        // 此处需要显示错误信息
        // return Promise.reject(result.error);
        if(result.error!=null && typeof(result.error)!='undefined'){
          Vue.prototype.$message({
              message: result.error,
              showClose:true,
              type: 'error'
          });
        }else{
          Vue.prototype.$message({
              message: "请求返回出错！",
              showClose:true,
              type: 'error'
          });
        }

        return Promise.reject(result.error);
      }

      // 返回结果
      return result.detail;
    }



    // 对响应数据做点什么
    //console.log('response:',response);
    /*if(response.status === 200){
      // 如果code != 0 是出错信息
      let result = response.data;
      if (result.code != 0) {
        console.log('result.code = ' + result.code+",result.error:"+result.error);
        // 此处需要显示错误信息
        // return Promise.reject(result.error);
        Vue.prototype.$message({
            message: result.error,
            showClose:true,
            type: 'error'
        });
        return Promise.reject(result.error);
      }

      // 返回结果
      return result.detail;*/

    }else{
      return Promise.reject(error);
    }
    return response;
  }, function (err) {
      if(err && err.response){
         switch (err.response.status) {
           case 400:
            err.message = '请求错误';
            break;

          case 401:
            err.message = '未授权，请登录';
            //登出系统
            Vue.prototype.$utils.logout();
            break;

          case 403:
            err.message = '拒绝访问';
            break;

          case 404:
            err.message = `请求地址出错: ${err.response.config.url}`;
            break;

          case 408:
            err.message = '请求超时';
            break;

          case 500:
            err.message = '服务器内部错误';
            break;

          case 501:
            err.message = '服务未实现';
            break;

          case 502:
            err.message = '网关错误';
            break;

          case 503:
            err.message = '服务不可用';
            break;

          case 504:
            err.message = '网关超时';
            //登出系统
            Vue.prototype.$utils.logout();
            break;

          case 505:
            err.message = 'HTTP版本不受支持';
            break;
          default:
            err.message = '请求错误';
        }

        Vue.prototype.$message({
            message:err.message,
            showClose:true,
            type: 'error'
        });
      }

    // 对响应错误做点什么
    return Promise.reject(err);
  });

export default server;



// WEBPACK FOOTER //
// ./src/server/index.js